import { Button, Typography } from '@mui/material';
import { dateToLabel } from 'further-ui/utils';
import ButtonGroup from 'components/ButtonGroup';
import Heading from 'components/Heading';
import Spacing from 'components/Spacing';

type InvestmentError = {
  investorName: string;
};

type Props = {
  investmentsWithBalanceErrors: Array<InvestmentError>;
  investmentsWithDateErrors: Array<InvestmentError>;
  isFee: boolean;
  dateEntered: Date;
  onGoBack: () => void;
  isBulk: boolean;
};

type InsufficientBalanceErrorProps = {
  investments: Array<InvestmentError>;
  isFee: boolean;
};
const InsufficientBalanceError: React.FC<InsufficientBalanceErrorProps> = ({
  investments,
  isFee,
}) => {
  return (
    <>
      <Heading variant="h3" noMargin>
        {isFee
          ? 'Investors have insufficient funds available'
          : 'Investors are unable to be given this discount'}
      </Heading>
      <Typography variant="body1">
        The following investors{' '}
        {isFee
          ? 'do not have sufficient cash available in their subscription for this additional fee to be charged.'
          : 'have been charged total fees that are less than the proposed discount.'}{' '}
        To continue, please go back and either reduce the{' '}
        {isFee ? 'fee' : 'discount'} amount or exclude these investors from the
        fee.
      </Typography>
      {investments?.map((investmentError, index) => (
        <Typography variant="body1" key={index}>
          {investmentError?.investorName}
        </Typography>
      ))}
    </>
  );
};

type IncorrectFeeDateErrorProps = {
  investments: Array<InvestmentError>;
  dateEntered: Date;
};
const IncorrectFeeDateError: React.FC<IncorrectFeeDateErrorProps> = ({
  investments,
  dateEntered,
}) => {
  return (
    <>
      <Heading variant="h2" noMargin>
        Invalid fee date entered
      </Heading>
      <Typography variant="body1">
        The date entered ({dateToLabel(dateEntered)}) is not valid for the
        following investors because it is before their initial subscription
        date. To continue, please amend the fee date or exclude these investors
        from the fee.
      </Typography>
      {investments?.map((investmentError, index) => (
        <Typography variant="body1" key={index}>
          {investmentError?.investorName}
        </Typography>
      ))}
    </>
  );
};

const FeesAndDiscountError: React.FC<Props> = ({
  investmentsWithBalanceErrors,
  investmentsWithDateErrors,
  isFee,
  dateEntered,
  onGoBack,
  isBulk,
}) => {
  return (
    <Spacing>
      {investmentsWithBalanceErrors?.length > 0 ? (
        <InsufficientBalanceError
          investments={investmentsWithBalanceErrors}
          isFee={isFee || isBulk}
        />
      ) : investmentsWithDateErrors.length > 0 ? (
        <IncorrectFeeDateError
          investments={investmentsWithDateErrors}
          dateEntered={dateEntered}
        />
      ) : null}
      <ButtonGroup>
        <Button color="primary" variant="contained" onClick={onGoBack}>
          Go back
        </Button>
      </ButtonGroup>
    </Spacing>
  );
};

export default FeesAndDiscountError;
